import React from 'react';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Mail, Phone, MapPin, Edit, Save, X } from 'lucide-react';

export const ContactInfoSection = ({ 
  contactInfo, setContactInfo, 
  isEditing, setIsEditing, 
  onSave, onCancel 
}) => {
  const fields = [
    { key: 'email', label: 'Email', icon: Mail },
    { key: 'phone', label: 'Phone', icon: Phone },
    { key: 'location', label: 'Location', icon: MapPin },
  ];

  return (
    <Card className="bg-black/50 border-orange-500/30 p-6">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-bold text-orange-400">Contact Information</h3>
        {!isEditing ? (
          <Button onClick={() => setIsEditing(true)} className="bg-orange-500 hover:bg-orange-600">
            <Edit className="w-4 h-4 mr-2" /> Edit
          </Button>
        ) : (
          <div className="flex gap-2">
            <Button onClick={onSave} className="bg-green-500 hover:bg-green-600">
              <Save className="w-4 h-4 mr-2" /> Save
            </Button>
            <Button onClick={onCancel} variant="outline" className="border-gray-500">
              <X className="w-4 h-4 mr-2" /> Cancel
            </Button>
          </div>
        )}
      </div>

      <div className="space-y-4">
        {fields.map(({ key, label, icon: Icon }) => (
          <div key={key} className="flex items-start space-x-4">
            <Icon className="w-5 h-5 text-orange-400 mt-1" />
            <div className="flex-1">
              <label className="text-sm text-gray-400 mb-1 block">{label}</label>
              {isEditing ? (
                <Input
                  value={contactInfo[key]}
                  onChange={(e) => setContactInfo({ ...contactInfo, [key]: e.target.value })}
                  className="bg-black/50 border-orange-500/30"
                />
              ) : (
                <p className="text-white">{contactInfo[key]}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
